<footer>
  <p class="footer--text">&copy; Copyright Switch2 Energy Limited 2018. All rights reserved.</p>
  <div class="footer--links">
    <a href="#top" class="text-link focus-element" [routerLink]="['/portal', 'roadmap']"><span class="focus--content" tabindex="-1" *ngIf="hasRoadMap && isLoggedIn">Roadmap</span></a>
      <a href="#top" class="text-link focus-element" [routerLink]="['/privacy-and-cookies']">
      <span class="focus--content" tabindex="-1">Privacy &amp; cookies</span></a>
      <a href="#top" class="text-link focus-element" [routerLink]="['/terms-and-conditions']"><span class="focus--content" tabindex="-1">Terms &amp; conditions</span></a>
  </div>
</footer>
